import { pdfjs } from 'react-pdf';

// Ensure worker is configured
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

/**
 * Generates a thumbnail image from the first page of a PDF
 * @param pdfData - The PDF as a Uint8Array
 * @param width - Target thumbnail width (height scales proportionally)
 * @returns PNG blob of the thumbnail
 */
export async function generatePdfThumbnail(
  pdfData: Uint8Array,
  width: number = 300
): Promise<Blob> {
  // Load the PDF document
  const loadingTask = pdfjs.getDocument({ data: pdfData });
  const pdf = await loadingTask.promise;

  // Get the first page
  const page = await pdf.getPage(1);

  // Calculate scale to achieve target width
  const viewport = page.getViewport({ scale: 1 });
  const scale = width / viewport.width;
  const scaledViewport = page.getViewport({ scale });

  // Create canvas
  const canvas = document.createElement('canvas');
  canvas.width = scaledViewport.width;
  canvas.height = scaledViewport.height;

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Could not get canvas context');
  }

  // Render the page
  await page.render({
    canvasContext: context,
    viewport: scaledViewport,
    canvas,
  }).promise;

  // Convert to blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to create thumbnail blob'));
        }
      },
      'image/png',
      0.9
    );
  });
}
